<template>
  <div>
    <el-form ref="form" :model="form" :label-width="formLabelWidth">
      <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="赠品">
            <div class="service-flex">
              <div
                class="service-content"
                v-for="tag in giftArr"
                :key="tag.id"
              >
                <div class="addClass-name">{{tag.name}}</div>
                <i
                  class="icon-close-style el-icon-error"
                  @click.stop="tagRemoveGiftList(tag.id)"
                ></i>
              </div>
            </div>
            <div class="service-checkbox">
              <span>请选择：</span><span class="service-text">已选{{giftArr.length}}</span>
              <el-button @click="addType = 2, addFormVisible = true" type="primary" size="mini" class="service-button">
                <i class="el-icon-plus"></i>赠品
              </el-button>
              <el-checkbox-group style="margin-left: 10px" v-model="form.giftList" @change="giftCheckboxChange">
                <el-checkbox v-for="(item, index) in giftList" :label="item.id" :key="index">{{item.name}}
                  <i v-if="item.addWay != 1" @click.stop.prevent="removeGiftList(item.id)" class="checkbox-remove el-icon-remove"></i>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="服务">
            <div class="service-flex">
              <div
                class="service-content"
                v-for="tag in serviceArr"
                :key="tag.id"
              >
                <div class="addClass-name">{{tag.name}}</div>
                <i
                  class="icon-close-style el-icon-error"
                  @click.stop="tagRemoveServiceList(tag.id)"
                ></i>
              </div>
            </div>
            <div class="service-checkbox">
              <span>请选择：</span><span class="service-text">已选{{serviceArr.length}}</span>
              <el-button @click="addType = 1, addFormVisible = true" type="primary" size="mini" class="service-button">
                <i class="el-icon-plus"></i>服务
              </el-button>
              <el-checkbox-group style="margin-left: 10px" v-model="form.serviceList" @change="serviceCheckboxChange">
                <el-checkbox v-for="(item, index) in serviceList" :label="item.id" :key="index">{{item.name}}
                  <i v-if="item.addWay != 1" @click.stop.prevent="removeServiceList(item.id)" class="checkbox-remove el-icon-remove"></i>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="退费" prop="name">
            <el-radio v-for="(item, index) in refundList" v-model="isRefund" :key="index" :label="item.id">{{item.name}}</el-radio>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div>
      <el-button style="margin-left: 50px" type="primary" @click="addOrUpdateAdditionGoodsRelation">提交
      </el-button>
    </div>


    <el-dialog :title="'新增'" :visible.sync="addFormVisible" width="30%" left :close-on-click-modal="false">
      <el-form :label-width="formLabelWidth">
        <el-form-item :label="addType == 1 ?'赠品':'服务'" label-width="40px">
          <el-input v-model="addForm.value"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addService">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
  export default {
    name: "Service",
    data() {
      return {
        goodsId: "",
        formLabelWidth: "86px",
        giftArr: [],
        serviceArr: [],
        form: {
          goodsId: "",
          serviceList: [],
          giftList: [],
          refundList: [],
        },
        isRefund: null,
        refundList: [],
        serviceList: [],
        giftList: [],
        addType: 1,
        addForm: {
          value: ""
        },
        addFormVisible: false
      }
    },
    mounted() {
      this.goodsId = this.$route.query.updatePageId;
      this.form.goodsId = this.goodsId;
      this.getAdditionGoodsList(1);
    },
    methods: {
      // 获取赠品列表 + 服务列表
      getAdditionGoodsList (type) {
        this.api.additionGoods.getAdditionGoodsList({ goodsId: this.goodsId }).then(res => {
          this.giftList = res.data.giftList;
          this.serviceList = res.data.serviceList;
          this.refundList = res.data.refundList;
          if(type == 1) {
            this.getAdditionGoodsRelation();
          }
        })
      },
      // 获取服务详情
      getAdditionGoodsRelation() {
        this.api.additionGoodsRelation.getAdditionGoodsRelation({ goodsId: this.goodsId }).then(res => {
          if(res.success) {
            if(res.data.giftList) {
              this.$set(this.form, "giftList", res.data.giftList);
            }
            if(res.data.serviceList) {
              this.$set(this.form, "serviceList", res.data.serviceList);
            }
            if(res.data.refundList) {
              this.isRefund = res.data.refundList[0];
            }
            this.serviceCheckboxChange();
            this.giftCheckboxChange();
          } else {
            this.$Message.error(res.message)
          }
        })
      },

      serviceCheckboxChange() {
        this.$nextTick(() => {
          this.serviceArr = this.serviceList.filter(item => this.form.serviceList.includes(item.id));
        })
      },
      giftCheckboxChange() {
        this.$nextTick(() => {
          this.giftArr = this.giftList.filter(item => this.form.giftList.includes(item.id));
        })
      },

      // 删除服务
      tagRemoveServiceList(id) {
        let index = this.form.serviceList.indexOf(id);
        if(index > -1) {
          this.form.serviceList.splice(index, 1);
          this.serviceCheckboxChange();
        }
      },
      // 删除赠品
      tagRemoveGiftList(id) {
        let index = this.form.giftList.indexOf(id);
        if(index > -1) {
          this.form.giftList.splice(index, 1);
          this.giftCheckboxChange();
        }
      },
      // 移除服务列
      removeServiceList(id) {
        this.tagRemoveServiceList(id);
        if(id) {
          this.deleteAdditionGoodsRelation(id);
        }
      },
      // 移除赠品列
      removeGiftList(id) {
        this.tagRemoveGiftList(id);
        if(id) {
          this.deleteAdditionGoodsRelation(id);
        }
      },
      // 删除服务类型
      deleteAdditionGoodsRelation(id) {
        this.api.additionGoods
          .deleteAdditionGoods({id: id})
          .then(result => {
            if (result.success) {
              this.getAdditionGoodsList(2);
              this.$message.success(result.message)
            } else {
              this.$message.error(result.message)
            }
          })
      },
      // 提交
      addOrUpdateAdditionGoodsRelation() {
        if(this.isRefund) {
          this.form.refundList = [this.isRefund]
        }
        this.api.additionGoodsRelation
          .addOrUpdateAdditionGoodsRelation(this.form)
          .then(result => {
            if (result.success) {
              this.$message.success(result.message)
            } else {
              this.$message.error(result.message)
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      // 关闭弹窗 | 新增服务项
      addService() {
        if(!this.addForm.value) {
          this.$message.error("请输入内容")
          return
        }
        let obj = {
          name: this.addForm.value,
          goodsId: this.goodsId,
          type: "赠品"
        }
        if (this.addType == 1) {
          obj.type = "服务"
          this.serviceList.push({name: this.addForm.value, isAllowDel: 1})
        } else {
          obj.type = "赠品"
          this.giftList.push({name: this.addForm.value, isAllowDel: 1})
        }
        this.api.additionGoods
          .addAdditionGoods(obj)
          .then(res => {
            if(res.success) {
              this.getAdditionGoodsList();
              // if (_this.addType == 1) {
              //   _this.serviceList.push({name: _this.addForm.value, isAllowDel: 1})
              // } else {
              //   _this.giftList.push({name: _this.addForm.value, isAllowDel: 1})
              // }
              this.addForm.value = ""
              this.addFormVisible = false
            }
          })
      }
    }
  }
</script>

<style scoped>
  .service-flex {
    display: flex;
  }

  .service-content {
    display: flex;
    justify-content: center;
    padding-left: 10px;
    padding-right: 10px;
    background: #409eff;
    height: 32px;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 13px;
    border-radius: 4px;
    margin-right: 20px;
    margin-bottom: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .icon-close-style {
    float: right;
    line-height: 32px;
    margin-left: 20px;
    cursor: pointer;
  }

  .service-button {
    position: absolute;
    right: 0;
  }

  .service-checkbox {
    background-color: #edf1f2;
    border-radius: 4px;
  }

  .checkbox-remove {
    margin-left: 10px;
    font-size: 14px;
  }

  .service-text {
    color: #409eff;
  }

</style>



// WEBPACK FOOTER //
// src/components/goods/components/Service.vue